import { ApiKey, ApiPathManager, ServiceCode } from "app/shared/services/api-path";
import { getDataHeaders, getUserHeader } from "app/shared/services/header-builder";
import { EBACCOUNTDEPOSITS, REQUESTINPUT } from "app/shared/services/services-model.type";
import { instance } from "app/shared/util/token-store";
import {
  DataTermDepositCreate,
  FetchTermDepositMaturityRequest,
  FetchTermDepositOpenAuthorizationRequest,
  FetchTermDepositOpenConfirmRequest,
  FetchTermDepositOpenCreateRequest,
  FetchTermDepositPromoCodeRequest,
  FetchTermDepositPromotionsRequest,
  FetchTermDepositTermRequest,
} from "../reducer/types";

export const fetchTermDepositInfoService = async () => {
  const { action, massageID, url } = ApiPathManager(ApiKey.TERM_DEPOSIT_INFO);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

export const fetchTermDepositTermService = async (actionRq: FetchTermDepositTermRequest) => {
  const { action, massageID, url } = ApiPathManager(ApiKey.TERM_DEPOSIT_PERIOD);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    EBACCOUNT_DEPOSITS: {
      PREFIX_DESCRIPTION: actionRq.payload,
    },
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

export const fetchTermDepositMaturityService = async (actionRq: FetchTermDepositMaturityRequest) => {
  const { action, massageID, url } = ApiPathManager(ApiKey.TERM_DEPOSIT_EXPIRE);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    EBACCOUNT_DEPOSITS: {
      PREFIX_DESCRIPTION: actionRq.payload,
    },
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

const createOpenParam = (payload?: DataTermDepositCreate) => {
  const data: EBACCOUNTDEPOSITS = {
    CREDIT_BRANCH_CODE: payload?.BRANCH?.value.replace("BRANCH", ""),
    CREDIT_BANK_NAME: "PVcomBank",
    DEBIT_ACCOUNT_NUMBER: payload?.ACCOUNT_DEBIT?.ACCOUNTNO,
    DEBIT_ACCOUNT_CURRENCY: payload?.ACCOUNT_DEBIT?.CURRENCYCODE || "VND",
    DEPOSIT_TERM: payload?.TERM?.value,
    DEPOSIT_TERM_CODE: payload?.TERM?.label,
    PREFIX_DESCRIPTION: "OPEN TERM DEPOSIT",
    PRODUCT_CODE: payload?.PRODUCT?.value,
    RENEWAL_CODE: payload?.MATURITY?.value,
    SERVICE_CODE: ServiceCode.TERM_DEPOSIT_OPEN,
    TRANSACTION_AMOUNT: payload?.AMOUNT,
    TRANSACTION_DESCRIPTION: "OPEN TERM DEPOSIT",
    PROCODE: payload?.PROMO_CODE || "",
  };
  return data;
};

const confirmOpenParam = (action: FetchTermDepositOpenConfirmRequest) => {
  const data: EBACCOUNTDEPOSITS = {
    ...action.payload?.EBACCOUNT_DEPOSITS,
    PREFIX_DESCRIPTION: "OPEN TERM DEPOSIT",
    CREDIT_AMOUNT: action.payload?.EBACCOUNT_DEPOSITS?.TRANSACTION_AMOUNT,
    DEBIT_AMOUNT: action.payload?.EBACCOUNT_DEPOSITS?.TRANSACTION_AMOUNT,
    DEBIT_ACCOUNT_CURRENCY: action.payload?.EBACCOUNT_DEPOSITS?.DEBIT_ACCOUNT_CURRENCY || "VND",
  };
  return data;
};

export const fetchTermDepositOpenCheckCodeService = async (actionRq: FetchTermDepositPromoCodeRequest) => {
  const { action, massageID, url } = ApiPathManager(ApiKey.TERM_DEPOSIT_OPEN_CHECK_CODE);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const ebAccountDeposit = createOpenParam(actionRq?.payload);
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    EBACCOUNT_DEPOSITS: ebAccountDeposit,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

export const fetchTermDepositOpenCreateService = async (actionRq: FetchTermDepositOpenCreateRequest) => {
  const { action, massageID, url } = ApiPathManager(ApiKey.TERM_DEPOSIT_OPEN_CREATE);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const ebAccountDeposit = createOpenParam(actionRq.payload);
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    EBACCOUNT_DEPOSITS: ebAccountDeposit,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

export const fetchTermDepositOpenConfirmService = async (actionRq: FetchTermDepositOpenConfirmRequest) => {
  const { action, massageID, url } = ApiPathManager(ApiKey.TERM_DEPOSIT_OPEN_CONFIRM);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const ebAccountDeposit = confirmOpenParam(actionRq);
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    EBACCOUNT_DEPOSITS: ebAccountDeposit,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

export const fetchTermDepositOpenAuthService = async (actionRq: FetchTermDepositOpenAuthorizationRequest) => {
  const { action, massageID, url } = ApiPathManager(ApiKey.TERM_DEPOSIT_OPEN_AUTH);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    AUTHORIZE_CODE: actionRq.code,
    CHALLENGE_ID: actionRq.payload?.CHALLENGE_ID,
    EBACCOUNT_DEPOSITS: {
      ...actionRq.payload?.EBACCOUNT_DEPOSITS,
      PREFIX_DESCRIPTION: "OPEN TERM DEPOSIT",
    },
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

export const fetchTermDepositPromotionsService = async (actionRq: FetchTermDepositPromotionsRequest) => {
  const { action, massageID, url } = ApiPathManager(ApiKey.TERM_DEPOSIT_OPEN_PROMOTIONS);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    EBACCOUNT_DEPOSITS: actionRq.payload?.EBACCOUNT_DEPOSITS,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};
